import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import React, { useEffect, useRef } from "react";

const QuillEditor = React.memo(function QuillEditor({ value, onChange }) {
    const { quill, quillRef } = useQuill({
        theme: "snow",
        modules: {
            toolbar: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link"],
                [{ align: [] }],
            ],
        },
        formats: [
            "header",
            "bold",
            "italic",
            "underline",
            "list",
            "bullet",
            "link",
            "align",
        ],
        placeholder: "Write content...",
    });

    const isSettingInitial = useRef(false);

    // 🔹 When Quill becomes ready, set API value into editor
    useEffect(() => {
        if (quill && value && !isSettingInitial.current) {
            isSettingInitial.current = true;
            quill.clipboard.dangerouslyPasteHTML(value);  // preserves formatting
        }
    }, [quill, value]);

    // 🔹 Listen for editor changes & update parent state
    useEffect(() => {
        if (!quill) return;

        const handler = () => {
            const html = quill.root.innerHTML;
            onChange(html);
        };

        quill.on("text-change", handler);

        return () => {
            quill.off("text-change", handler);
        };
    }, [quill]);

    return (
        <div className="quill-wrapper">
            <div ref={quillRef} style={{ minHeight: 120 }} />
        </div>
    );
});

export default QuillEditor;
